//#region libraries
//react&libraries
import React, { useState, useEffect } from 'react';
import { SocialIcon } from 'react-social-icons';
import { useMediaQuery } from 'react-responsive'
import validator from 'validator';
//custom components
import { NavBarNew, Footer, MobilePage } from '_molecules';
import { FAQ } from '_atoms';
//bootstrap
import { Button, Container, Col, Form, Row, ToastContainer, Toast } from 'react-bootstrap';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { reset as resetContact, selectContactStatus, postMessage } from '_redux/slices/website/contact';
//styles
import './styles.css';
//#endregion
function Contact() {
    //#region Responsive design
    const isPhone = useMediaQuery({ query: '(max-width: 1224px)' })
    //#endregion

    //#region State
    // state variables for form
    const [firstName, setFirstName] = useState("");                            //first name
    const [secondName, setSecondName] = useState("");                          //second name
    const [email, setEmail] = useState("");                                    //email
    const [companyName, setCompanyName] = useState(" ");                       //company name
    const [message, setMessage] = useState("");                                //message
    const [showSuccessText, setShowSuccessText] = useState(false);             //show success text after submit  
    const [contactStatusText, setContactStatusText] = useState("init");        //contact status text
    const [showContactStatusToast, setShowContactStatusToast] = useState(false);
    const [showBadFirstToast, setShowBadFirstToast] = useState(false);
    const [showBadSecondToast, setShowBadSecondToast] = useState(false);
    const [showBadEmailToast, setShowBadEmailToast] = useState(false);
    const [showBadMessageToast, setShowBadMessageToast] = useState(false);

    //#endregion

    //#region redux
    const dispatch = useDispatch();
    const contactStatus = useSelector(selectContactStatus);
    //#endregion

    //#region functions for handling submit
    // handle submission
    const handleFormSubmission = (e) => {
        e.preventDefault(); // needed to prevent auto refresh

        // copy validator stuff
        let isValidEmail = validator.isEmail(email)
        let isValidFirst = validator.isEmpty(firstName)
        let isValidSecond = validator.isEmpty(secondName)
        let isValidMessage = validator.isEmpty(message)

        if (!isValidEmail) {
            toggleShowBadEmailToast();
        }
        if (isValidFirst) {
            toggleShowBadFirstToast();
        }
        if (isValidSecond) {
            toggleShowBadSecondToast();
        }
        if (isValidMessage) {
            toggleShowBadMessageToast();
        }
        if (isValidEmail && !isValidFirst && !isValidSecond && !isValidMessage && contactStatus != 'loading') {
            let fullName = firstName + ' ' + secondName;
            dispatch(postMessage({
                name: fullName,
                email: email,
                company: companyName,
                message: message
            }));
        }

    };
    //#endregion

    //#region useEffect
    // intialize contact as empty on page opening
    useEffect(() => {
        dispatch(resetContact());
    }, []);
    console.log(contactStatus, "contactStatus")

    // check on status of slice
    useEffect(() => {
        if (contactStatus == 'idle') setShowContactStatusToast(false);
        if (contactStatus == 'loading') {
            setContactStatusText(`Sending ${email} message...`);
        }
        else if (contactStatus == 'failed') {
            setContactStatusText(`Failed to send ${email} contact message`);
        }
        else if (contactStatus == 'succeeded') {
            setFirstName("")
            setSecondName("")
            setEmail("")
            setCompanyName("")
            setMessage("")
            setContactStatusText(`Sucessfully submitted your request`);
        }
        if (!showContactStatusToast && contactStatus != 'idle') {
            //toggleShowContactStatusToast();
            setShowSuccessText(true)
        }
    }, [contactStatus]);
    //#endregion

    //#region toastify messages
    // toasts for bad first name
    const toggleShowBadFirstToast = () => setShowBadFirstToast(!showBadFirstToast);

    //  toasts for bad second
    const toggleShowBadSecondToast = () => setShowBadSecondToast(!showBadSecondToast);

    // toasts for bad email
    const toggleShowBadEmailToast = () => setShowBadEmailToast(!showBadEmailToast);

    // toasts for bad message
    const toggleShowBadMessageToast = () => setShowBadMessageToast(!showBadMessageToast);

    // toasts for saving tester status     
    const toggleShowContactStatusToast = () => setShowContactStatusToast(!showContactStatusToast);
    //#endregion

    if (!isPhone) {
        return (
            <div>
                <NavBarNew from={'contact-us'} />
                <Container fluid={true} className="mt-5 mb-5">
                    <Container className="mt-5">
                        <Row>
                            <Col className='mt-5'>
                                <h1 className="fw-bold fs-1 mt-5">Contact Us</h1>
                                <p className="fw-lighter fs-4 mt-5">Get in touch with us by filling out this form and you will receive a response via email.</p>
                            </Col>
                            <Col className='mt-5'>
                                <Form onSubmit={handleFormSubmission}>
                                    {/* Name */}
                                    <Form.Group>
                                        <Row>
                                            <Form.Label>Name</Form.Label>
                                            <Col>
                                                <Form.Control placeholder="First" type="text" onChange={(e) => setFirstName(e.target.value)} />
                                            </Col>
                                            <Col>
                                                <Form.Control placeholder="Surname" type="text" onChange={(e) => setSecondName(e.target.value)} />
                                            </Col>
                                        </Row>
                                    </Form.Group>

                                    {/* Email */}
                                    <Form.Group className="mb-3 mt-3" controlId="formEmail">
                                        <Row>
                                            <Form.Label> Email </Form.Label>
                                            <Col>
                                                <Form.Control type="text" placeholder="name@example.com" onChange={(e) => setEmail(e.target.value)} />
                                            </Col>
                                        </Row>
                                    </Form.Group>

                                    {/* Company Name */}
                                    <Form.Group>
                                        <Row>
                                            <Form.Label>Company Name</Form.Label>
                                            <Col>
                                                <Form.Control type="text" onChange={(e) => setCompanyName(e.target.value)} />
                                            </Col>
                                        </Row>
                                    </Form.Group>

                                    {/* Message */}
                                    <Form.Group className="mt-4">
                                        <Row>
                                            <Form.Label>Message</Form.Label>
                                            <Col>
                                                <Form.Control as="textarea" style={{ height: '100px' }} type="text" placeholder="Type your message here..." onChange={(e) => setMessage(e.target.value)} />
                                            </Col>
                                        </Row>
                                    </Form.Group>

                                    <Button variant="primary" type="submit" className='mt-5'>
                                        Submit
                                    </Button>
                                    {
                                        showSuccessText ?
                                            <p style={{ marginTop: 5, color: 'green' }}>{contactStatusText}</p>
                                            :
                                            null
                                    }
                                </Form>
                                {/* Toast */}
                                <ToastContainer position='bottom-end'>
                                    {/* first */}
                                    <Toast show={showBadFirstToast} onClose={toggleShowBadFirstToast} bg='warning'>
                                        <Toast.Header>
                                            <strong className='me-auto'>PRM Assist</strong>
                                        </Toast.Header>

                                        <Toast.Body>Please enter a valid first name</Toast.Body>
                                    </Toast>
                                    {/* second */}
                                    <Toast show={showBadSecondToast} onClose={toggleShowBadSecondToast} bg='warning'>
                                        <Toast.Header>
                                            <strong className='me-auto'>PRM Assist</strong>
                                        </Toast.Header>

                                        <Toast.Body>Please enter a valid second name</Toast.Body>
                                    </Toast>
                                    {/* email */}
                                    <Toast show={showBadEmailToast} onClose={toggleShowBadEmailToast} bg='warning'>
                                        <Toast.Header>
                                            <strong className='me-auto'>PRM Assist</strong>
                                        </Toast.Header>

                                        <Toast.Body>Please enter a valid email address</Toast.Body>
                                    </Toast>
                                    {/* message */}
                                    <Toast show={showBadMessageToast} onClose={toggleShowBadMessageToast} bg='warning'>
                                        <Toast.Header>
                                            <strong className='me-auto'>PRM Assist</strong>
                                        </Toast.Header>

                                        <Toast.Body>Please enter a valid message</Toast.Body>
                                    </Toast>
                                    {/* status */}
                                    <Toast show={showContactStatusToast} onClose={toggleShowContactStatusToast} bg={contactStatus == 'failed' ? 'danger' : contactStatus == 'succeeded' ? 'success' : 'light'} >
                                        <Toast.Header>
                                            <strong className='me-auto'>PRM Assist</strong>
                                        </Toast.Header>

                                        <Toast.Body>{contactStatusText}</Toast.Body>
                                    </Toast>
                                </ToastContainer>
                            </Col>
                        </Row>
                    </Container>
                </Container>

                <Footer />
            </div>
        );
    }
    else {
        return (
            <>
                <NavBarNew from={'contact-us'} />
                <Container>
                    <Row>
                        <Col>
                            <h1 className="fw-bold fs-1 mt-5">Contact Us</h1>
                            <p className="fw-lighter fs-4 ">Get in touch with us by filling this form and you will receive a response via email.</p>
                        </Col>
                    </Row>
                    <Row>
                        <Form onSubmit={handleFormSubmission}>
                            {/* Name */}
                            <Form.Group>
                                <Row>
                                    <Form.Label>Name</Form.Label>
                                    <Col>
                                        <Form.Control placeholder="First" value={firstName} type="text" onChange={(e) => setFirstName(e.target.value)} />
                                    </Col>
                                    <Col>
                                        <Form.Control placeholder="Surname" value={secondName} type="text" onChange={(e) => setSecondName(e.target.value)} />
                                    </Col>
                                </Row>
                            </Form.Group>

                            {/* Email */}
                            <Form.Group className="mb-3 mt-3" controlId="formEmail">
                                <Row>
                                    <Form.Label> Email </Form.Label>
                                    <Col>
                                        <Form.Control type="text" value={email} placeholder="name@example.com" onChange={(e) => setEmail(e.target.value)} />
                                    </Col>
                                </Row>
                            </Form.Group>

                            {/* Company Name */}
                            <Form.Group>
                                <Row>
                                    <Form.Label>Company Name</Form.Label>
                                    <Col>
                                        <Form.Control type="text" value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                                    </Col>
                                </Row>
                            </Form.Group>

                            {/* Message */}
                            <Form.Group className="mt-4">
                                <Row>
                                    <Form.Label>Message</Form.Label>
                                    <Col>
                                        <Form.Control as="textarea" value={message} style={{ height: '100px' }} type="text" placeholder="Type your message here..." onChange={(e) => setMessage(e.target.value)} />
                                    </Col>
                                </Row>
                            </Form.Group>

                            <Button variant="primary" type="submit" className='mt-5'>
                                Submit
                            </Button>
                        </Form>
                        {/* Toast */}
                        <ToastContainer position='bottom-end'>
                            {/* first */}
                            <Toast show={showBadFirstToast} onClose={toggleShowBadFirstToast} bg='warning'>
                                <Toast.Header>
                                    <strong className='me-auto'>PRM Assist</strong>
                                </Toast.Header>

                                <Toast.Body>Please enter a valid first name</Toast.Body>
                            </Toast>
                            {/* second */}
                            <Toast show={showBadSecondToast} onClose={toggleShowBadSecondToast} bg='warning'>
                                <Toast.Header>
                                    <strong className='me-auto'>PRM Assist</strong>
                                </Toast.Header>

                                <Toast.Body>Please enter a valid second name</Toast.Body>
                            </Toast>
                            {/* email */}
                            <Toast show={showBadEmailToast} onClose={toggleShowBadEmailToast} bg='warning'>
                                <Toast.Header>
                                    <strong className='me-auto'>PRM Assist</strong>
                                </Toast.Header>

                                <Toast.Body>Please enter a valid email address</Toast.Body>
                            </Toast>
                            {/* message */}
                            <Toast show={showBadMessageToast} onClose={toggleShowBadMessageToast} bg='warning'>
                                <Toast.Header>
                                    <strong className='me-auto'>PRM Assist</strong>
                                </Toast.Header>

                                <Toast.Body>Please enter a valid message</Toast.Body>
                            </Toast>
                            {/* status */}
                            <Toast show={showContactStatusToast} onClose={toggleShowContactStatusToast} bg={contactStatus == 'failed' ? 'danger' : contactStatus == 'succeeded' ? 'success' : 'light'} >
                                <Toast.Header>
                                    <strong className='me-auto'>PRM Assist</strong>
                                </Toast.Header>

                                <Toast.Body>{contactStatusText}</Toast.Body>
                            </Toast>
                        </ToastContainer>
                    </Row>
                </Container>

                <MobilePage
                    title="Get Help"
                    subtitle="At PRM Assist, we want to ensure that you get the help you need whether that is with your travel assistance, or with your PRM Assist account."
                    subsubtitle="Before reaching out to one of our customer support agents, please take a look at some of our FAQ's."
                    image={<FAQ />}
                    reverse={true}
                />

                {/* <Container fluid={true} className="bg-light mt-5">
                    <Row className='mt-5'>
                        <Col className="mt-5">
                            <h1 className="fw-bold fs-1">Our Social Media</h1>
                            <p className="fw-lighter fs-4 mt-3">Follow our journey and keep up to date with everything PRM Assist.</p>
                        </Col>
                    </Row>
                    <Row className='p-3 d-flex justify-content-between'>
                        <SocialIcon url="https://twitter.com/" />
                        <SocialIcon url="https://facebook.com/" />
                        <SocialIcon url="https://linkedin.com/" />
                    </Row>
                </Container> */}
                <Footer />
            </>
        );
    }
};
//
export default Contact;